"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "What is included in a home inspection?",
    answer: "A home inspection is a visual evaluation of accessible systems and components, including the roof, exterior, interior, attic when accessible, electrical, plumbing, HVAC, appliances, and visible moisture concerns."
  }, {
    question: "How long does a home inspection take?",
    answer: "Most home inspections take about 1.5 to 3 hours depending on the property size, age, condition, and add‑on services requested."
  }, {
    question: "When will I receive my report?",
    answer: "Reports are typically delivered within 24 hours, and often the same day when scheduling and report workload allow."
  }, {
    question: "Do you offer wind mitigation and 4‑point inspections?",
    answer: "Yes. Trusted Inspections provides wind mitigation and 4‑point inspections commonly requested by Florida insurance carriers."
  }, {
    question: "Do you offer mold testing or sewer camera inspections?",
    answer: "Yes. Mold testing and sewer camera inspections are available as add‑on services when requested."
  }, {
    question: "Do I need to attend the inspection?",
    answer: "Attendance is not required, but buyers and agents are welcome to attend near the end of the inspection for a summary of the main findings."
  }];
  return;
}